import { ISearchHandelssortimentModel } from "~app/features/forsaljning/handelssortiment/handelssortiment.models";

export class MinaHandelssortimentResultViewModel {
    constructor(private readonly model: ISearchHandelssortimentModel) {
    }

    get id() {
        return this.model.id;
    }

    get namn() {
        return this.model.namn;
    }

    get handelssortimentsgrupp() {
        return this.model.handelssortimentsgrupp.namn;
    }

    get produkter() {
        return this.model.produkter != null ? this.maxLength(this.model.produkter.map(p => p.namn).join(", ")) : "";
    }

    get aktiv() {
        return this.model.aktiv;
    }

    get sekvensnummer() {
        return this.model.handelssortimentsgrupp.sekvensnummer;
    }

    get innerModel(): ISearchHandelssortimentModel {
        return this.model;
    }

    maxLength(s: string) {
        return s && s.length > 60 ? `${s.substring(0, 57)}...` : s;
    }
}
